import type { MetaParams } from './meta-params';
import type { UTMParams } from './utm-params';

/**
 * Set completo de atribución que el backend acepta y persiste
 * (`lead_source_attributions`). Todos opcionales.
 */
export interface AttributionPayload {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  utm_id?: string;
  fbclid?: string;
  fbp?: string;
  fbc?: string;
  meta_event_id?: string;
  ad_id?: string;
  adset_id?: string;
  campaign_id?: string;
  platform?: string;
}

/**
 * Fuente única para ensamblar TODOS los params de atribución (UTM + Meta) en un
 * objeto plano, descartando null/undefined/'' para no enviar campos vacíos.
 *
 * Antes cada landing listaba a mano qué campos reenviar y divergían: unas
 * mandaban `fbc`/ids y otras no, el quiz `/leads/contacts` no mandaba nada.
 * Centralizar aquí garantiza que cada submit reenvíe el set completo.
 *
 * @param metaEventId  id devuelto por el pixel (trackConversion) para dedupe
 *   exacto browser↔CAPI; si se omite se usa `metaParams.meta_event_id` (mismo
 *   id de sesión que usa el pixel, así que también deduplica).
 */
export function buildAttributionPayload(
  utmParams: UTMParams,
  metaParams: MetaParams,
  metaEventId?: string,
): AttributionPayload {
  const raw: Record<string, string | null | undefined> = {
    utm_source: utmParams.utm_source,
    utm_medium: utmParams.utm_medium,
    utm_campaign: utmParams.utm_campaign,
    utm_content: utmParams.utm_content,
    utm_term: utmParams.utm_term,
    utm_id: utmParams.utm_id,
    fbclid: metaParams.fbclid,
    fbp: metaParams.fbp,
    fbc: metaParams.fbc,
    meta_event_id: metaEventId ?? metaParams.meta_event_id,
    ad_id: metaParams.ad_id,
    adset_id: metaParams.adset_id,
    campaign_id: metaParams.campaign_id,
    platform: metaParams.platform,
  };

  const out: AttributionPayload = {};
  for (const [key, value] of Object.entries(raw)) {
    if (value != null && value !== '') {
      (out as Record<string, string>)[key] = value;
    }
  }
  return out;
}
